export enum AuthType {
    // Fortinet Employee authentication for admin access
    EMPLOYEE_FAC = 'FortiFAC',

    // Customer authentication using FortiCloud
    CUSTOMER_FORTICLOUD = 'FortiCloud',
}
